import {
  API_URI,
  APP_ENV,
  APP_VERSION,
  DD_APPLICATION_ID,
  DD_CLIENT_TOKEN,
  DD_SESSION_REPLAY_SAMPLE_RATE,
  DD_SESSION_SAMPLE_RATE,
  DD_SITE
} from "@saleor/config";

const datadogScript = `
    (function(h,o,u,n,d) {
        h=h[d]=h[d]||{q:[],onReady:function(c){h.q.push(c)}}
        d=o.createElement(u);d.async=1;d.src=n
        n=o.getElementsByTagName(u)[0];n.parentNode.insertBefore(d,n)
    })(window,document,'script','https://www.datadoghq-browser-agent.com/us1/v6/datadog-rum.js','DD_RUM')
    window.DD_RUM.onReady(function() {
        window.DD_RUM.init({
        clientToken: '${DD_CLIENT_TOKEN}',
        applicationId: '${DD_APPLICATION_ID}',
        // site refers to the Datadog site parameter of your organization
        // see https://docs.datadoghq.com/getting_started/site/
        site: '${DD_SITE}',
        service: 'scgp-eordering-frontend',
        env: '${APP_ENV}',
        // Specify a version number to identify the deployed version of your application in Datadog
        version: '${APP_VERSION}',
        allowedTracingUrls: ['${API_URI}'],
        sessionSampleRate: ${DD_SESSION_SAMPLE_RATE},
        sessionReplaySampleRate: ${DD_SESSION_REPLAY_SAMPLE_RATE},
        trackUserInteractions: true,
        trackResources: true,
        trackLongTasks: true,
        defaultPrivacyLevel: 'mask-user-input',
        sessionPersistence: 'local-storage'
        });
    })
`;

const addError = e => {
  if (window.DD_RUM) {
    window.DD_RUM.onReady(function() {
      window.DD_RUM.addError(e);
    });
  }
};

export { datadogScript, addError };
